import { atom, useAtomValue } from 'jotai/index'
import { getDiscountCoupons, usableTotalAmount } from '../../store/discountCoupon'
import { totalAmount$ } from '../../store/payment'
import { member$ } from '../../store/stateMachine/state'
import type { ReserveInputMember } from '../../store/stateMachine/state'

const disabledDiscountCoupon$ = atom((get) => {
  return filteredDisabledDiscountCoupon(get(member$), get(totalAmount$))
})
disabledDiscountCoupon$.debugLabel = 'disabledDiscountCoupon$'

export function useDisabledDiscountCoupon() {
  return useAtomValue(disabledDiscountCoupon$)
}

function filteredDisabledDiscountCoupon(
  member: ReserveInputMember | undefined,
  totalAmount: number
) {
  if (!member) {
    return []
  }
  const coupons = getDiscountCoupons(member)
  return coupons.filter((coupon) => {
    return !usableTotalAmount(coupon, totalAmount)
  })
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('filteredDisabledDiscountCoupon', async () => {
    expect(
      filteredDisabledDiscountCoupon(
        {
          discountCoupons: [
            {
              name: '割引クーポン',
              price: 1000,
              code: '1234567890',
              reservablePeriod: { from: '2021-01-01', to: '2021-01-02' },
              visitablePeriod: { from: '2021-01-01', to: '2021-01-02' },
              minimumReservationAmount: 1000,
            },
            {
              name: '最低適用金額以下のクーポン',
              price: 2000,
              code: '1234567890',
              reservablePeriod: { from: '2021-01-01', to: '2021-01-02' },
              visitablePeriod: { from: '2021-01-01', to: '2021-01-02' },
              minimumReservationAmount: 2000,
            },
          ],
        } as unknown as ReserveInputMember,
        1000
      )
    ).toEqual([
      {
        name: '最低適用金額以下のクーポン',
        price: 2000,
        code: '1234567890',
        reservablePeriod: { from: '2021-01-01', to: '2021-01-02' },
        visitablePeriod: { from: '2021-01-01', to: '2021-01-02' },
        minimumReservationAmount: 2000,
      },
    ])
  })
}
